import {
  Users,
  FileCheck2,
  ShieldCheck,
  Key,
  Lock,
  Server,
  Activity,
  Settings,
} from "lucide-react";
import {
  HeaderKpi,
  SectionCard,
  RowItem,
  CenterHeader,
} from "./center/CenterPrimitives";

export default function PlatformGovernanceCenterView({ onBack, onOpenSub }: { onBack: () => void; onOpenSub?: (id: string) => void }) {
  return (
    <div className="flex flex-col gap-5">
      <CenterHeader
        title="Platform Governance Center"
        scope="IAM · Compliance · Audit · Vault · Infrastructure · Monitoring"
        onBack={onBack}
      />

      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <HeaderKpi icon={Users} value="12" label="Utilisateurs actifs" delta="0%" tone="neutral" seed={1} />
        <HeaderKpi icon={FileCheck2} value="18" label="Politiques actives" delta="+2%" tone="success" seed={2} />
        <HeaderKpi icon={ShieldCheck} value="94%" label="Compliance score" delta="+1%" tone="success" seed={3} />
        <HeaderKpi icon={Key} value="47" label="Secrets Vault" delta="+3%" tone="success" seed={4} />
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
        <SectionCard title="Identity & Access" scope="Utilisateurs · RBAC · MFA · Médecins · Cotations" icon={Users} tone="success">
          <div className="space-y-2">
            <RowItem title="Utilisateurs" hint="Comptes + RBAC + MFA + Keycloak" onClick={() => onOpenSub?.("identity-access")} />
            <RowItem title="Médecins" hint="INPE + spécialité + NGAP" onClick={() => onOpenSub?.("doctors")} />
            <RowItem title="Cotations" hint="NGAP par spécialité · assignation médecins" onClick={() => onOpenSub?.("cotations")} />
          </div>
        </SectionCard>

        <SectionCard title="Compliance" scope="HIPAA · GDPR · IEC 62304 · ISO 14971 · FDA" icon={FileCheck2} tone="success">
          <div className="space-y-2">
            <RowItem title="HIPAA · GDPR" hint="Privacy + Sécurité" />
            <RowItem title="IEC 62304" hint="Logiciels DM" />
            <RowItem title="ISO 14971" hint="Risk management" />
            <RowItem title="FDA 21 CFR 11" hint="Electronic records" />
          </div>
        </SectionCard>

        <SectionCard title="Audit Archive" scope="WORM · Hash chain · Immutable · Rétention 7 ans" icon={ShieldCheck} tone="success">
          <div className="space-y-2">
            <RowItem title="Audit WORM" hint="Hash chain integrity" />
            <RowItem title="Regulatory Ledger" hint="Journal réglementaire" />
            <RowItem title="Établissements" hint="Multi-tenant config" />
          </div>
        </SectionCard>

        <SectionCard title="Vault & KMS" scope="Coffre-fort · Clés cryptographiques · Rotation" icon={Lock} tone="success">
          <div className="space-y-2">
            <RowItem title="Vault" hint="47 secrets stockés" />
            <RowItem title="KMS" hint="Clés AES256GCM + rotation" />
            <RowItem title="Vault infrastructure" hint="Cluster HashiCorp" />
          </div>
        </SectionCard>

        <SectionCard title="Infrastructure" scope="Kubernetes · PostgreSQL · Redis · Kafka · ArgoCD" icon={Server} tone="success">
          <div className="space-y-2">
            <RowItem title="Kubernetes" hint="Cluster prod" onClick={() => onOpenSub?.("kubernetes")} />
            <RowItem title="PostgreSQL" hint="Supabase primary" onClick={() => onOpenSub?.("postgres")} />
            <RowItem title="Redis" hint="Upstash cache + pub/sub" onClick={() => onOpenSub?.("redis")} />
            <RowItem title="Kafka" hint="Event streaming" onClick={() => onOpenSub?.("kafka")} />
            <RowItem title="ArgoCD" hint="GitOps deploy" />
          </div>
        </SectionCard>

        <SectionCard title="Monitoring & Observability" scope="Prometheus · Grafana · Loki · Alertmanager · SLO" icon={Activity} tone="warning">
          <div className="space-y-2">
            <RowItem title="Grafana" hint="Dashboards ops" />
            <RowItem title="Prometheus" hint="Métriques + alertes" />
            <RowItem title="Loki" hint="Logs centralisés" />
            <RowItem title="Alertmanager" hint="Routing + silences" />
            <RowItem title="SLO" hint="Objectifs niveau service" />
          </div>
        </SectionCard>
      </div>

      <SectionCard title="Machines & Templates" scope="Configuration · Calibration · Auto-test · Templates" icon={Settings} tone="neutral">
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          <RowItem title="Machines" hint="Templates + calibration" onClick={() => onOpenSub?.("machines")} />
          <RowItem title="Consultations atomiques" hint="Optimistic locking" onClick={() => onOpenSub?.("consultations-atomiques")} />
          <RowItem title="Settings" hint="Drawer configuration" />
        </div>
      </SectionCard>
    </div>
  );
}
